<template>
  <div class="content container-fluid">
    <breadcrumb-index :items="breadcrumbs" />

    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Edit Course</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Course Name <span class="text-danger">*</span></label>
              <input v-model="form.name" type="text" class="form-control" required />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Course Code <span class="text-danger">*</span></label>
              <input v-model="form.code" type="text" class="form-control" required />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Category <span class="text-danger">*</span></label>
              <select v-model="form.category" class="form-select" required>
                <option value="">Select Category</option>
                <option value="science">Science</option>
                <option value="mathematics">Mathematics</option>
                <option value="language">Language</option>
                <option value="social">Social Studies</option>
                <option value="other">Other</option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Status</label>
              <select v-model="form.status" class="form-select">
                <option value="draft">Draft</option>
                <option value="active">Active</option>
                <option value="archived">Archived</option>
              </select>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Description</label>
            <textarea v-model="form.description" class="form-control" rows="3"></textarea>
          </div>

          <div class="mb-3">
            <label class="form-label">Thumbnail</label>
            <input type="file" class="form-control" @change="handleThumbnail" accept="image/*" />
            <small class="text-muted">Leave empty to keep current thumbnail</small>
          </div>

          <div v-if="error" class="alert alert-danger">{{ error }}</div>

          <div class="d-flex gap-2">
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
              Update Course
            </button>
            <router-link to="/app/courses/list" class="btn btn-secondary">Cancel</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/services/api'
import { useAlert } from '@/plugins/sweetalert'

export default {
  name: 'EditCourse',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const alert = useAlert()
    const breadcrumbs = [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Courses', url: '/app/courses/list' },
      { title: 'Edit Course', active: true }
    ]

    const form = ref({ name: '', code: '', category: '', status: 'draft', description: '' })
    const thumbnail = ref(null)
    const loading = ref(false)
    const error = ref('')

    const fetchCourse = async () => {
      try {
        const response = await api.get(`/v1/admin/courses/${route.params.id}`)
        form.value = response.data.course
      } catch (err) {
        alert.error('Error', 'Course not found')
        router.push('/app/courses/list')
      }
    }

    const handleThumbnail = (e) => { thumbnail.value = e.target.files[0] }

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''

      const formData = new FormData()
      Object.keys(form.value).forEach(key => formData.append(key, form.value[key]))
      if (thumbnail.value) formData.append('thumbnail', thumbnail.value)

      try {
        await api.put(`/v1/admin/courses/${route.params.id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        alert.success('Success', 'Course updated successfully')
        router.push('/app/courses/list')
      } catch (err) {
        error.value = err.response?.data?.message || 'Failed to update course'
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchCourse)

    return { breadcrumbs, form, loading, error, handleThumbnail, handleSubmit }
  }
}
</script>
